import { createContext, useContext } from 'react';

/**
 * Datepicker context used in child components (DateField, Calendar)
 * It allows those components to know that they're in the DatePicker vs when they're used by themselves
 */
type DatePickerContextType = {
  isInDatePicker?: boolean;
  isInDateRangePicker?: boolean;
};

export const DatePickerContext = createContext<DatePickerContextType>({
  isInDatePicker: false,
  isInDateRangePicker: false,
});

// Create a hook that automatically calls the context without having to import both
export const useDatePickerContext = () => useContext(DatePickerContext);
